export default __webpack_public_path__ + "static/media/mobileDownloadIcon.7d98b390.svg";